import React from "react";
import SendInvoiceForm from "./SendInvoiceForm";

const App = () => {
  return <SendInvoiceForm />;
};

export default App;
